import React, {useEffect, useState} from "react";
import fetcher from 'lib/utils/fetcher'
import {getCons} from 'lib/food/cons'
import {getPros} from 'lib/food/pros'
import axios from "axios";
import SeoData from '@/components/core/SeoData'
import contentStyles from "@/public/styles/pages/food/product.module.scss";
import Breadcrumbs from "@/components/common/Breadcrumbs";
import Tags from "@/components/blog/Tags"
import Image from 'next/image';
import Link from "next/link";
import PostMicroSeoMarkup from "@/components/blog/food/PostMicroSeoMarkup";
import {getRate} from "lib/food/rate";
import {getLink} from "lib/food/links";
import {connect} from "react-redux";
import {wrapper} from "@/store/store";
import cx from "classnames";
import AppCaloriesBanner from "@/components/common/AppCaloriesBanner";
import AppDefaultBanner from "@/components/common/AppDefaultBanner";

const API_HOST = process.env.NEXT_PUBLIC_API_URL
const DOMAIN = process.env.NEXT_PUBLIC_DOMAIN

declare global {
    interface Window {
        yaContextCb: {};
    }
}

export const getServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
    ctx.res.setHeader(
        "Cache-Control",
        "max-age=300, stale-while-revalidate=60, stale-if-error=86400"
    );

    if (!ctx.params) {
        return {
            notFound: true,
        }
    }
    const {urlKey} = ctx.params;

    let item: any = false;
    let related: any = [];
    let category: any = false;
    let relatedQuestions: any = false;

    try {
        let fetchUrl = `${API_HOST}/api/food/item/${urlKey}`
        item = await fetcher(fetchUrl);
    } catch (e) {
        console.log(e.message)
    }

    if (!item) {
        return {
            notFound: true,
        }
    }

    try {
        let fetchUrl = `${API_HOST}/api/food/category/id/${item.category_id}`
        category = await fetcher(fetchUrl);
    } catch (e) {
        console.log(e.message)
    }

    try {
        let fetchUrl = `${API_HOST}/api/food/item/same?page_size=3`
        let response = await axios.post(fetchUrl, {food_id: item.food_id, category_id: item.category_id});
        related = response.data
    } catch (e) {
        console.log(e.message)
    }

    return {
        props: {
            item: item,
            category: category,
            related: related,
            relatedQuestions: relatedQuestions
        }
    };
})

function getItemNutrient(nutrients, name) {
    let nutrient = nutrients.find(e => e.name == name)
    if (!nutrient) {
        return 0;
    }
    return nutrient.value.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]
}

function Item(props) {
    const {item, related, category, isMobile} = props

    let proteins100 = getItemNutrient(item.nutrients, 'Белки');
    let fats100 = getItemNutrient(item.nutrients, 'Жиры');
    let carbohydrates100 = getItemNutrient(item.nutrients, 'Углеводы');
    let calories100 = getItemNutrient(item.nutrients, 'Калорийность');

    const [weight, setWeight] = useState(100)
    const [proteins, setProteins] = useState(proteins100)
    const [fats, setFats] = useState(fats100)
    const [carbohydrates, setCarbohydrates] = useState(carbohydrates100)
    const [calories, setCalories] = useState(calories100)

    let itemTags = [];

    const toFixedWithoutZeros = (num, precision) =>
        num.toFixed(precision).replace(/\.0+$/, '');

    function handleWeightChange(event) {
        if (event.target.value > 90000) {
            return;
        }
        setWeight(event.target.value)
        setProteins(toFixedWithoutZeros(proteins100/100*parseInt(event.target.value), 2))
        setFats(toFixedWithoutZeros(fats100/100*parseInt(event.target.value), 2))
        setCarbohydrates(toFixedWithoutZeros(carbohydrates100/100*parseInt(event.target.value),2))
        setCalories(toFixedWithoutZeros(calories100/100*parseInt(event.target.value),2))
    }

    let breadcrumbs = [];

    breadcrumbs.push({
        path: "/food/calories",
        title: 'Калорийность продуктов'
    })

    if (category) {
        breadcrumbs.push({
            path: '/food/category/' +  category.url_key,
            title: category.name
        })
    } else {
        breadcrumbs.push({
            path: "/food/calories",
            title: item.category_name
        })
    }


    breadcrumbs.push({
        path: '',
        title: item.name,
        disabled: true
    })

    let pros = getPros(item)
    let cons = getCons(item)

    let rate: any = getRate(item, pros, cons)

    // @ts-ignore
    return (
        <>
            <SeoData title={`Калорийность ${item.name}. Химический состав и пищевая ценность.`}
                     description={`Калорийность ${item.name}. Энергетическая и пищевая ценность, химический состав, витамины и минералы. Польза и вред ${item.name}. Содержание белка, Жира, Улеводов.`}
                     keywords={`Калорийность, ${item.name}, энергетическая и пищевая ценность, витамины`}
                     article={
                         {
                             category: item.category_name,
                             tags: itemTags,
                             created_at: item.createdAt,
                             updated_at: item.updatedAt
                         }
                     }
                     ogType={'article'}
                     hideFromRobots={false} />

            {
                !isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }

            <div className={cx(contentStyles.contentContainer, {[contentStyles.noCrumbs]: isMobile})}>
                <h1 className={contentStyles.postTitle}>Калорийность {item.name.toLowerCase()}. Химический состав и пищевая ценность.</h1>
                <div className={contentStyles.description}>
                    Пищевая ценность продукта {item.name.toLowerCase()}. В данном разделе вам доступна полная таблица в которой содержится значение калорий, белков, жиров и углеводов на 100 грамм массы, то есть КБЖУ состав продукта {item.name.toLowerCase()}. Помимо основных макронутриентов справочник содержит подробную информацию о микронутриентах: витамины, минеральные вещества (микроэлементы и макроэлементы).
                </div>

                <div style={{['margin-top' as any]: "20px"}}>
                    <AppDefaultBanner />
                </div>

                <div className={contentStyles.rate}>
                    <div className={contentStyles.title}><h2>Расчет пищевой ценности</h2> на <input type="number" min={1} max={99000} value={weight} onChange={handleWeightChange}/> г.</div>
                    <div className={contentStyles.stats}>
                        <div className={contentStyles.statList}>
                            <div className={contentStyles.stat}>
                                <div className={contentStyles.title}>Белок</div>
                                <div className={contentStyles.value}>{proteins}</div>
                                <div className={contentStyles.ed}>грамм</div>
                            </div>
                            <div className={contentStyles.stat}>
                                <div className={contentStyles.title}>Жиры</div>
                                <div className={contentStyles.value}>{fats}</div>
                                <div className={contentStyles.ed}>грамм</div>
                            </div>
                            <div className={contentStyles.stat}>
                                <div className={contentStyles.title}>Углеводы</div>
                                <div className={contentStyles.value}>{carbohydrates}</div>
                                <div className={contentStyles.ed}>грамм</div>
                            </div>
                            <div className={contentStyles.stat}>
                                <div className={contentStyles.title}>Калории</div>
                                <div className={contentStyles.value}>{calories}</div>
                                <div className={contentStyles.ed}>ккал</div>
                            </div>
                        </div>
                        <div className={contentStyles.description}>
                            Введите значение в поле выше в граммах, для получения расчета по макронутриентам и калорийности на введенное количество грамм
                        </div>
                    </div>
                </div>

                <div className={contentStyles.pros}>
                    <h2>Чем полезен {item.name.toLowerCase()}?</h2>
                    {pros.map((val) => {
                        return <p>{val}</p>
                    })}
                </div>

                <div className={contentStyles.cons}>
                    <h2>Чем вреден продукт {item.name.toLowerCase()}?</h2>
                    <p>Из вредных компонентов и негативных особенностей в продукте {item.name.toLowerCase()} можно выделить:</p>
                    {cons.map((val) => {
                        return <p>- {val}</p>
                    })}
                </div>
                <div className={contentStyles.rating}>
                    <img src={'/images-local/gym-dynamic-color.png'} alt={'Рейтинг продукта'} />
                    <span className={contentStyles.title}>Рейтинг продукта {rate.rate} из 5</span>
                    <p>{rate.text}</p>
                </div>

                <div className={contentStyles.nutrients}>
                    <h2>Пищевая ценность и химический состав "{item.name}".</h2>
                    <p>В таблице приведено содержание пищевых веществ (калорийности, белков, жиров, углеводов, витаминов и минералов, аминокислот, жирных кислот) на 100 грамм съедобной части.</p>
                    <div className={contentStyles.tableWrap}>
                        <table>
                            <thead>
                                <tr>
                                    <th className={contentStyles.name}>Нутриент</th>
                                    <th className={contentStyles.value}>Количество на 100 г</th>
                                    <th className={contentStyles.rateValue}>Норма</th>
                                    <th className={contentStyles.ratePercent}>% от нормы</th>
                                </tr>
                            </thead>
                            <tbody>
                            {item.nutrients.map((nutrient) => {
                                let link = getLink(nutrient.name)
                                return <tr>
                                    {
                                        link == "" && <td className={contentStyles.name}>{nutrient.type == 'group' ? nutrient.name.toUpperCase() : nutrient.name}</td>
                                    }
                                    {
                                        link != "" && <td className={contentStyles.name}><Link href={link}><a>{nutrient.type == 'group' ? nutrient.name.toUpperCase() : nutrient.name}</a></Link> </td>
                                    }
                                    <td>{nutrient.value}</td>
                                    <td>{nutrient.rate}</td>
                                    <td>{nutrient.rate_100_g}</td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>
                    <div className={contentStyles.source}>
                        * {item.source}
                    </div>
                </div>

                <div className={contentStyles.calAlert}>
                    <img src={'/images-local/fire-dynamic-color.png'} alt={'Калькулятор калорий'}/>
                    <span className={contentStyles.alertTitle}>Важно!</span>
                    <span>Не забудь рассчитать свою норму калорий и макронутриентов, свой идеальный вес и ИТМ, используя наши умные калькуляторы:</span>
                </div>

                <div className={contentStyles.calculatorsList}>
                    <Link href={'/calculator/calculator-kbzu-dla-pohudenia'}>
                        <a className={contentStyles.calculator}>
                            <div className={contentStyles.imageWrap}><Image src={'/images-local/product/4.png'} width={104} height={82} quality={100} alt={'Калькулятор для расчета калорий и макронутриентов для похудения'}/></div>
                            <div className={contentStyles.content}>Если твоя цель снижения веса, то используй Калькулятор для расчета калорий и макронутриентов для похудения</div>
                        </a>
                    </Link>
                    <Link href={'/calculator/raschet-kalorij-dlya-nabora-massy'}>
                        <a className={contentStyles.calculator}>
                            <div className={contentStyles.imageWrap}><Image src={'/images-local/product/5.png'} width={104} height={82} quality={100} alt={'Калькулятор для расчета калорий и макронутриентов для набора мышечной массы'}/></div>
                            <div className={contentStyles.content}>Если твоя цель набор массы, то используй Калькулятор для расчета калорий и макронутриентов для набора мышечной массы</div>
                        </a>
                    </Link>
                    <Link href={'/calculator/calculator-kbzu-online'}>
                        <a className={contentStyles.calculator}>
                            <div className={contentStyles.imageWrap}><Image src={'/images-local/product/3.png'} width={104} height={82} quality={100} alt={'Калькулятор для расчета калорий и макронутриентов для поддержки веса на текущем уровне'}/></div>
                            <div className={contentStyles.content}>Если твоя цель поддержать форму, то используй Калькулятор для расчета калорий и макронутриентов для поддержки веса на текущем уровне</div>
                        </a>
                    </Link>
                    <Link href={'/calculator/kalkulyator-idealnogo-vesa'}>
                        <a className={contentStyles.calculator}>
                            <div className={contentStyles.imageWrap}><Image src={'/images-local/product/1.png'} width={104} height={82} quality={100} alt={'Калькулятор для расчета идеального веса'}/></div>
                            <div className={contentStyles.content}>Калькулятор для расчета идеального веса, поможет понять, какой вес является самым подходящим для вашего роста и комплекции</div>
                        </a>
                    </Link>
                    <Link href={'/calculator/imt-calculator-online'}>
                        <a className={contentStyles.calculator}>
                            <div className={contentStyles.imageWrap}><Image src={'/images-local/product/2.png'} width={104} height={82} quality={100} alt={'Калькулятор ИТМ (индекса массы тела)'}/></div>
                            <div className={contentStyles.content}>Калькулятор ИТМ (индекса массы тела) позволяет определить степень ожирения</div>
                        </a>
                    </Link>
                </div>

                <div className={contentStyles.related}>
                    <div className={contentStyles.title}>
                        Похожие продукты в этой категории:
                    </div>
                    {related.map((relate) => {
                        return <div className={contentStyles.relatedItem}>
                            <Link href={'/food/calories/'+relate.url_key}><a>{relate.name}. Химический состав и пищевая ценность.</a></Link>
                        </div>
                    })}
                    
                </div>

                <div id="toggle-visible"></div>
                <div className={contentStyles.postTags}>
                    <Tags tags={itemTags}/>
                </div>
            </div>

            {
                isMobile &&
                <Breadcrumbs
                    items={breadcrumbs}
                />
            }

            <PostMicroSeoMarkup post={
                {
                    name: item.name,
                    urlKey: item.url_key,
                    createdAt: item.createdAt,
                    updatedAt: item.createdAt,
                    contentShort: `Калорийность ${item.name}. Энергетическая и пищевая ценность, химический состав, витамины и минералы. Польза и вред ${item.name}. Содержание белка, Жира, Улеводов.`,
                    content: `Содержание калорий, белков, жиров, углеводов в ${item.name} на 100 грам продукта. Справочник содержит БЖУ продукта, подробную информацию о его составе - витамины, минералы, микроэлементы и макроэлементы.`,
                    bigImage: {
                        fileUrl: 'https://api.wayout.fitness/public/images/post/633204e58e2ce8001b0c9d4b/preview_image/4051.png'
                    }
                }
            } category={{name: item.category_name}}/>
        </>

    )
}

function mapStateToProps(state) {
    return {
        isMobile: state.core.is_mobile
    }
}

export default connect(mapStateToProps)(Item)